import React from 'react';
import { Typography, Box } from '@mui/material';

function Clients() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Client Management
      </Typography>
      <Typography variant="body1">
        Client management functionality coming soon...
      </Typography>
    </Box>
  );
}

export default Clients; 